// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"1zRs3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _vue = require("vue");
var _buefy = require("buefy");
var _buefyDefault = parcelHelpers.interopDefault(_buefy);
var _utilsJs = require("./ts/utils.js");
var _popupLauncherVue = require("./pages/PopupLauncher.vue");
var _popupLauncherVueDefault = parcelHelpers.interopDefault(_popupLauncherVue);
// EAUTH2-232
(0, _utilsJs.reloadPageIfCached)();
var app = (0, _vue.createApp)((0, _popupLauncherVueDefault.default));
//@ts-ignore
app.use((0, _buefyDefault.default), (0, _utilsJs.buefyConfig));
app.mount('#app');
(0, _utilsJs.keepalive)(false);

},{"vue":"jc5UF","buefy":"jLHUS","./ts/utils.js":"4iE5H","./pages/PopupLauncher.vue":"aSMMo","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aSMMo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = require("c1f3d39b0676955f");
    if (script.__esModule) script = script.default;
    script.render = require("77484cb4a1697189").render;
    require("f60dcab564975837").default(script);
    script.__scopeId = 'data-v-276aea';
    script.__file = "PopupLauncher.vue";
};
initialize();
exports.default = script;

},{"c1f3d39b0676955f":"lIEE8","77484cb4a1697189":"20LXW","f60dcab564975837":"hJtg8","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lIEE8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _vue = require("vue");
var _basicLayoutVue = require("../layouts/BasicLayout.vue");
var _basicLayoutVueDefault = parcelHelpers.interopDefault(_basicLayoutVue);
var _popupLauncherContentVue = require("./PopupLauncherContent.vue");
var _popupLauncherContentVueDefault = parcelHelpers.interopDefault(_popupLauncherContentVue);
exports.default = /*@__PURE__*/ (0, _vue.defineComponent)({
    __name: 'PopupLauncher',
    setup: function(__props, _a) {
        var __expose = _a.expose;
        __expose();
        var __returned__ = {
            BasicLayout: (0, _basicLayoutVueDefault.default),
            PopupLauncherContent: (0, _popupLauncherContentVueDefault.default)
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
});

},{"vue":"jc5UF","../layouts/BasicLayout.vue":"hqyso","./PopupLauncherContent.vue":"8ceGI","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hqyso":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = require("7043a24cccffcafd");
    if (script.__esModule) script = script.default;
    script.render = require("a3596e50552b1f88").render;
    script.__cssModules = require("ad0cdc1243cb4e2b").default;
    require("2e284ae458b64643").default(script);
    script.__scopeId = 'data-v-ef8544';
    script.__file = "BasicLayout.vue";
};
initialize();
exports.default = script;

},{"7043a24cccffcafd":"51Brd","a3596e50552b1f88":"l1IV8","ad0cdc1243cb4e2b":"1DNcm","2e284ae458b64643":"gmLrk","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"51Brd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _vue = require("vue");
var _eloUiCss = require("@elo/ui-buefy-v3/dist/elo-ui.css");
var _fontEloSansPro = require("@elo/font-elo-sans-pro");
var _eIconsCss = require("../css/e-icons.css");
var _utils = require("../ts/utils"); // EAUTH2-33
var _translations = require("../ts/translations");
exports.default = /*@__PURE__*/ (0, _vue.defineComponent)({
    __name: 'BasicLayout',
    setup: function(__props, _a) {
        var __expose = _a.expose;
        __expose();
        document.body.style.backgroundImage = "url('".concat((0, _utils.API_URL), "/branding/background')");
        var license = (0, _vue.ref)('ELO Digital Office');
        var status = (0, _vue.ref)(null);
        (0, _utils.fetchJson)((0, _utils.API_URL) + '/status').then(function(s) {
            return status.value = s;
        });
        var __returned__ = {
            license: license,
            status: status,
            Suspense: (0, _vue.Suspense),
            get $t () {
                return 0, _translations.$t;
            }
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
});

},{"vue":"jc5UF","@elo/ui-buefy-v3/dist/elo-ui.css":"81LGK","@elo/font-elo-sans-pro":"omINW","../css/e-icons.css":"fLMWM","../ts/utils":"4iE5H","../ts/translations":"eBebr","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"81LGK":[function() {},{}],"omINW":[function() {},{}],"fLMWM":[function() {},{}],"l1IV8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
const _hoisted_1 = {
    class: "has-background-warning"
};
const _hoisted_2 = {
    key: 0,
    class: "m-2"
};
const _hoisted_3 = {
    class: "boxed-container"
};
const _hoisted_4 = {
    class: "m-2"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_loading = (0, _vue.resolveComponent)("b-loading");
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), null, [
        (0, _vue.createElementVNode)("header", _hoisted_1, [
            $setup.status?.underMaintenance ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("p", _hoisted_2, (0, _vue.toDisplayString)($setup.$t('under_maintenance')), 1)) : (0, _vue.createCommentVNode)("", true)
        ]),
        (0, _vue.createElementVNode)("main", _hoisted_3, [
            _cache[0] || (_cache[0] = (0, _vue.createElementVNode)("div", {
                class: "logos"
            }, [
                (0, _vue.createElementVNode)("img", {
                    class: "logo-primary",
                    src: '../de.elo.ix.plugin.rest/auth2/branding/logo-primary',
                    alt: "logo-primary"
                }),
                (0, _vue.createElementVNode)("img", {
                    class: "logo-secondary",
                    src: '../de.elo.ix.plugin.rest/auth2/branding/logo-secondary',
                    alt: "logo-secondary"
                })
            ], -1)),
            ((0, _vue.openBlock)(), (0, _vue.createBlock)((0, _vue.Suspense), null, {
                fallback: (0, _vue.withCtx)(()=>[
                        (0, _vue.createVNode)(_component_b_loading)
                    ]),
                default: (0, _vue.withCtx)(()=>[
                        (0, _vue.renderSlot)(_ctx.$slots, "default")
                    ]),
                _: 3
            }))
        ]),
        (0, _vue.createElementVNode)("footer", null, [
            (0, _vue.createElementVNode)("p", _hoisted_4, (0, _vue.toDisplayString)($setup.status?.license ?? 'ELO Digital Office'), 1)
        ])
    ], 64);
}

},{"vue":"jc5UF","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1DNcm":[function() {},{}],"gmLrk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8ceGI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = require("101e5f03ee20490b");
    if (script.__esModule) script = script.default;
    script.render = require("ace74176de117b16").render;
    require("3e9f5e824e5a06c0").default(script);
    script.__scopeId = 'data-v-a47577';
    script.__file = "PopupLauncherContent.vue";
};
initialize();
exports.default = script;

},{"101e5f03ee20490b":"2u8X9","ace74176de117b16":"jNKib","3e9f5e824e5a06c0":"9QCDc","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2u8X9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _vue = require("vue");
var _utils = require("../ts/utils");
var _translations = require("../ts/translations");
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v1) {
            return step([
                n,
                v1
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
exports.default = /*@__PURE__*/ (0, _vue.defineComponent)({
    __name: 'PopupLauncherContent',
    setup: function(__props_1, _a) {
        return __awaiter(this, arguments, void 0, function(__props, _b) {
            function launchPopup() {
                if (popup) {
                    console.log('Closing popup');
                    popup.close(); // Avoid multiple popups by accident, but close and reopen it to popup again "on top"
                }
                console.log('Opening popup');
                // EAUTH2-24
                // EAUTH2-197: add search parameters coming from a bookmark
                popup = window.open('./sign-in' + window.location.search, 'ELO Login', 'popup,height=604,width=480');
            }
            var __temp, __restore, popup, signInChoices, base64urlHash, base64hash, query, __returned__;
            var _c, _d;
            var __expose = _b.expose;
            return __generator(this, function(_e) {
                switch(_e.label){
                    case 0:
                        __expose();
                        popup = null;
                        _c = (0, _vue.withAsyncContext)(function() {
                            return (0, _translations.loadMessages)();
                        }), __temp = _c[0], __restore = _c[1];
                        return [
                            4 /*yield*/ ,
                            __temp
                        ];
                    case 1:
                        _e.sent(), __restore();
                        _d = (0, _vue.withAsyncContext)(function() {
                            return (0, _utils.fetchJson)((0, _utils.API_URL) + '/sign-in-choices');
                        }), __temp = _d[0], __restore = _d[1];
                        return [
                            4 /*yield*/ ,
                            __temp
                        ];
                    case 2:
                        signInChoices = (__temp = _e.sent(), __restore(), __temp);
                        if (!signInChoices.client_id && window.location.hash) {
                            base64urlHash = window.location.hash.substring(1);
                            base64hash = base64urlHash.replace(/-/g, '+').replace(/_/g, '/');
                            query = atob(base64hash);
                            console.log("Re-doing /authorize call with query: ".concat(query));
                            window.location.replace("".concat((0, _utils.API_URL), "/authorize?").concat(query));
                        }
                        // See welcome page, triggering this function
                        window["onPopupLoginSuccess"] = function() {
                            // Once the user has signed in, redirect the IFrame to the original redirect URL
                            console.log('Closing popup');
                            popup.close();
                            // EAUTH2-244: do not include /sign-in & /popup-launcher pages in browser history
                            window.location.replace((0, _utils.API_URL) + "/back-to-client");
                        };
                        // EAUTH2-44
                        // Usually, popups triggered directly "on load" are blocked by browsers and ad-blockers.
                        // That is why the page with the button exists, since popups triggered by "user interaction" are usually allowed.
                        // Nevertheless, if popups "on load" are enabled (usually by the user authorizing it), this will enable the popup to be launched directly.
                        launchPopup();
                        __returned__ = {
                            get popup () {
                                return popup;
                            },
                            set popup (v){
                                popup = v;
                            },
                            launchPopup: launchPopup,
                            signInChoices: signInChoices,
                            get $t () {
                                return 0, _translations.$t;
                            }
                        };
                        Object.defineProperty(__returned__, '__isScriptSetup', {
                            enumerable: false,
                            value: true
                        });
                        return [
                            2 /*return*/ ,
                            __returned__
                        ];
                }
            });
        });
    }
});

},{"vue":"jc5UF","../ts/utils":"4iE5H","../ts/translations":"eBebr","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jNKib":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_button = (0, _vue.resolveComponent)("b-button");
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), null, [
        (0, _vue.createVNode)(_component_b_button, {
            type: "is-dark",
            class: "my-6",
            onClick: _cache[0] || (_cache[0] = ($event)=>$setup.launchPopup()),
            "data-test-id": "button-sign_in"
        }, {
            default: (0, _vue.withCtx)(()=>[
                    (0, _vue.createTextVNode)((0, _vue.toDisplayString)($setup.$t('sign_in')), 1)
                ]),
            _: 1
        }),
        (0, _vue.createElementVNode)("p", null, (0, _vue.toDisplayString)($setup.$t('check_popup')), 1)
    ], 64);
}

},{"vue":"jc5UF","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9QCDc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"20LXW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createBlock)($setup["BasicLayout"], null, {
        default: (0, _vue.withCtx)(()=>[
                (0, _vue.createVNode)($setup["PopupLauncherContent"])
            ]),
        _: 1
    });
}

},{"vue":"jc5UF","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hJtg8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}]},["1zRs3"], "1zRs3", "parcelRequiree3ab", {})

//# sourceMappingURL=popup-launcher.0fccf960.js.map
